/**
 * Gets the value defined by 'key' or the 'DEFAULT' value if undefined.
 * @param obj
 * @param key
 */
export function objectValueOrDefault<V = boolean>(
    obj: Record<string, V> & { DEFAULT: V },
    key: keyof typeof obj | null,
): V {
    if (!key) {
        return obj.DEFAULT;
    }
    const result = obj[key];
    if (result !== undefined) {
        return result;
    }

    return obj.DEFAULT;
}
